import { Link } from '@tanstack/react-router';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';
import { EventCard } from '@/components/events/EventCard';
import type { Event } from '@/lib/types/database';
import type { RsvpStatus } from '@/lib/types/events.types';

interface UpcomingEventsCarouselProps {
  events: Event[];
  getRsvpStatus: (eventId: number) => RsvpStatus;
  fileCounts?: Map<number, number>;
}

export function UpcomingEventsCarousel({
  events,
  getRsvpStatus,
  fileCounts,
}: UpcomingEventsCarouselProps) {
  return (
    <div className="mb-6">
      <h2 className="font-size font-semibold text-primary mb-3">
        Upcoming Events
      </h2>
      {events.length === 0 ? (
        <div className="flex justify-center items-center py-12 rounded-lg border border-dashed border-foreground/20">
          <p className="text-body text-foreground/60">
            No upcoming events scheduled
          </p>
        </div>
      ) : (
        <>
          <Carousel opts={{ align: 'start' }} className="w-full mb-4">
            <CarouselContent className="-ml-2">
              {events.map((event) => (
                <CarouselItem key={event.id} className="pl-2 basis-[85%]">
                  <EventCard
                    yGrow
                    event={event}
                    rsvpStatus={getRsvpStatus(event.id)}
                    fileCount={fileCounts?.get(event.id) ?? 0}
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
          <div className="flex justify-center">
            <Link
              to="/events"
              className="text-body text-purple-300 underline font-field-62 justify-center"
            >
              See All Events
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
